import { UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import InputFormField from 'src/registry/components/forms/InputFormField';
import { Form } from 'src/registry/ui/Form';
import { commonMessages } from 'src/utils/messages';
import SelectFormField from 'src/registry/components/forms/SelectFormField';
import { AccountingRangeFormSchemaValues } from 'src/features/accountingRanges/utils/formSchema';
import { BOOLEAN_MAP, BOOLEAN_OPTIONS } from 'src/features/moneyAccounts/utils/constants';
import { accountingRangesMessages } from 'src/features/accountingRanges/utils/messages';
import SearchSelectFormField from 'src/registry/components/forms/SearchSelectFormField';
import { billingMessages } from 'src/features/billing/utils/messages';
import React from 'react';
import { useListBillingEntities } from 'src/features/billing/api/useListBillingEntities';

type AccountingRangeFormProps = {
    form: UseFormReturn<AccountingRangeFormSchemaValues>;
    onSubmit: (values: AccountingRangeFormSchemaValues) => void;
};

function AccountingRangeForm({ onSubmit, form }: AccountingRangeFormProps) {
    const { formatMessage } = useIntl();

    const [searchBillingEntity, setSearchBillingEntity] = React.useState<string>('');

    const { data: billingEntities } = useListBillingEntities({
        search: searchBillingEntity,
    });

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <InputFormField<AccountingRangeFormSchemaValues>
                form={form}
                name="name"
                label={formatMessage(commonMessages.name)}
            />
            <InputFormField<AccountingRangeFormSchemaValues>
                form={form}
                name="start"
                type="number"
                label={formatMessage(accountingRangesMessages.start)}
            />
            <InputFormField<AccountingRangeFormSchemaValues>
                form={form}
                name="end"
                type="number"
                label={formatMessage(accountingRangesMessages.end)}
            />
            <SelectFormField<AccountingRangeFormSchemaValues>
                form={form}
                name="is_manual"
                isBoolean={true}
                required={false}
                label={formatMessage(accountingRangesMessages.isManual)}
                options={Object.values(BOOLEAN_OPTIONS)}
                optionTranslationMap={BOOLEAN_MAP}
            />
            <SearchSelectFormField
                name="billing_entity"
                control={form.control}
                label={formatMessage(billingMessages.billingEntity)}
                items={billingEntities?.results ?? []}
                clearable
                placeholder={`${formatMessage(billingMessages.billingEntity)}...`}
                searchPlaceholder={formatMessage(billingMessages.searchBillingEntity)}
                emptyTitle={formatMessage(billingMessages.noBillingEntity)}
                emptyDescription={formatMessage(billingMessages.noBillingEntityFound)}
                getItemValue={(entity) => entity.id}
                getItemLabel={(entity) => entity.name}
                getItemKeywords={(entity) => [entity.name]}
                loadOptions={setSearchBillingEntity}
            />
        </Form>
    );
}

export default AccountingRangeForm;
